import * as React from 'react'

import { ImageTextBlockNew } from 'components/image-text-block-new/ImageTextBlockNew'
import { Text, TextName } from 'sdk'

import { data } from './data'

import classes from './style.module.scss'

export const PartnerProducts: React.FC = () => {
  return (
    <section className={classes.content}>
      {data.map(({ title, imageDesktop, imageMobile, description, textFirst, link, linkText }) => (
        <ImageTextBlockNew
          key={title}
          imageDesktop={imageDesktop}
          imageMobile={imageMobile}
          title={title}
          reverse={textFirst}
          buttonLink={link}
          buttonText={linkText}
          aspectRatio='1/1'
        >
          <Text type={TextName.Text}>{description}</Text>
        </ImageTextBlockNew>
      ))}
    </section>
  )
}
